// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_lq-0";
export var buttonContainer = "_lq-3";
export var cancelButton = "_lq-4";
export var headerSection = "_lq-6";
export var headerTitle = "_lq-9";
export var messageSideLeft = "_lq-1";
export var messageSideRight = "_lq-2";
export var orderNumberContainer = "_lq-7";
export var orderNumberLabel = "_lq-8";
export var submitButton = "_lq-5";